import { INTERVIEW_PARTICIPANT_MODEL } from "@/models/interview-participant-model";
import { INTERVIEW_FEEDBACK_MODEL } from "@/models/interview-feedback-model";

export const INTERVIEW_SLOT_MODEL = "interview-slot";
export const INTERVIEW_SLOTS_UNFILLED_MODEL = "interview-slot-unfilled";

const interviewSlotModel = {
  id: "",
  startTime: "",
  endTime: "",
  available: false,
  filled: false,
  existing: false,
  candidate: null,
  cancelled: false,
  interviewFormat: {
    jsonApi: "hasOne",
    type: "interview-format"
  },
  interviewers: [],
  interviewerAdditionalDetails: "",
  candidateAdditionalDetails: "",
  location: {
    jsonApi: "hasOne",
    type: "addresses"
  },
  participants: {
    jsonApi: "hasMany",
    type: INTERVIEW_PARTICIPANT_MODEL
  },
  feedbacks: {
    jsonApi: "hasMany",
    type: INTERVIEW_FEEDBACK_MODEL
  },
  comments: {
    jsonApi: "hasMany",
    type: "comment"
  }
};

export default interviewSlotModel;
